import { SiService, SiteService } from "../mappings";

export enum MerchantType {
    SUB_MERCHANT = 'SUB_MERCHANT',
    DIRECT_MERCHANT = 'DIRECT_MERCHANT',
}

export enum MerchantStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
    REJECTED = 'REJECTED',
}

const { BRAND_DETECT_SERVICE, TRACE_SERVICE, ...restSiServices } = SiService;

export const SiteIntelligenceSiService = {
    ...restSiServices,
} as const;

export type SiteIntelligenceSiService = typeof SiteIntelligenceSiService[keyof typeof SiteIntelligenceSiService];

export const SiteIntelligenceSiteService = {
    ...SiteService,
    SI_SERVICE: 'SI_SERVICE',
} as const;

export type SiteIntelligenceSiteService = typeof SiteIntelligenceSiteService[keyof typeof SiteIntelligenceSiteService];

export enum QuotaSourceType {
    ALLOCATE = 'ALLOCATE',
    PURCHASE = 'PURCHASE',
    SYSTEM = 'SYSTEM'
}

export enum QuotaStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum QuotaType {
    NORMAL = 'NORMAL',
    FREE = 'FREE',
    EXTENDED = 'EXTENDED',
}

export enum ReviewPriority {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH', // For new merchant that needed approval
    VIP = 'VIP',
}

export enum ApproveRequired {
    REQUIRED = "REQUIRED",
    NOT_REQUIRED = "NOT_REQUIRED",
    AUTO_APPROVE = "AUTO_APPROVE",
    CONDITIONAL_AUTO_DONE = 'CONDITIONAL_AUTO_DONE',
}

export enum UiExcluded {
    MCC = 'MCC'
}